import { IGetAllProjetosChecklistUseCase } from "../../../presentation/useCases/read/get_all_projetos_checklist_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";
import { ChecklistLista } from "../../models/checklist_Lista";


export class GetAllProjetosChecklistUseCase
  extends BasePaginatedUseCase<ChecklistLista>
  implements IGetAllProjetosChecklistUseCase
{
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async getAllProjetosChecklist(page: number, rowsPerPage: number, nome: string, status: number): Promise<void> {
    const response = await this.repository.getAllProjetosChecklist(
      page,
      rowsPerPage,
      nome,
      status
    );
    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
